import * as React from "react";

import { cn } from "../../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Validation error state — red border/ring + aria-invalid. */
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, "aria-invalid": ariaInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        aria-invalid={ariaInvalid ?? (error || undefined)}
        className={cn(
          "flex h-11 w-full rounded-coronis border border-coronis-gray-200 bg-white px-4 py-2 text-sm text-coronis-navy-600 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-coronis-navy-600 placeholder:text-coronis-gray-400 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-coronis-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/25 dark:bg-white/[0.08] dark:text-white dark:ring-offset-slate-900 dark:placeholder:text-white/40 dark:file:text-slate-200 dark:focus-visible:border-coronis-blue-500/50 transition-colors",
          error && "border-red-500 focus-visible:ring-red-500 dark:border-red-500/70",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
